import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=bf1e5f7e&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=bf1e5f7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1e5f7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf1e5f7e')) {
      api.createRecord('bf1e5f7e', component.options)
    } else {
      api.reload('bf1e5f7e', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=bf1e5f7e&scoped=true&", function () {
      api.rerender('bf1e5f7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2o2TaOdLCZXTj/JS/comp/PopupDialog.vue"
export default component.exports